import { differenceInYears, format, formatDistanceToNow, formatISO, getMonth, getYear } from 'date-fns'
import { ru } from 'date-fns/locale'
import { DATE_FNS_PATTERN_DATE } from './formats'

export {
  DATE_FNS_PATTERN_DATE,
  DATE_FNS_PATTERN_DAY_MONTH,
  DATE_FNS_PATTERN_DAY_OF_MONTH,
  DATE_FNS_PATTERN_ISO_DAY,
  DATE_FNS_PATTERN_ISO_MONTH,
  DATE_FNS_PATTERN_MONTH_LONG,
  DATE_FNS_PATTERN_TIME_HM,
  DATE_FNS_PATTERN_WEEKDAY_LONG,
  DATE_FNS_PATTERN_YEAR,
  DATE_LOCAL_NOON_SUFFIX,
} from './formats'

export {
  buildLocalDateTimeIso,
  getBrowserIanaTimezone,
  localDayAndTimeToUtcIso,
  localDayEndToUtcIso,
  localDayStartToUtcIso,
  parseApiDateTimeToFormFields,
  spanUtcIsoRangeForMonthKeys,
} from './formDatetime'

export {
  coerceIsoCalendarDay,
  formatIsoCalendarDay,
  formatIsoMonthKey,
  getTodayIsoCalendarDay,
  parseIsoDateOrDayKey,
} from './isoCalendarDay'

export {
  formatTimeHm,
  formatTimeOfDay,
  formatTimeRu,
} from './timeFormat'

export function formatDateRu(date: Date): string {
  return format(date, DATE_FNS_PATTERN_DATE, { locale: ru })
}

export function getCurrentYear(): number {
  return getYear(new Date())
}

export function getCurrentMonth(): number {
  return getMonth(new Date()) + 1
}

export function getCurrentDateISO(): string {
  return formatISO(new Date())
}

export function getAgeWithSuffix(birthday?: string, withFullSuffix = false): string {
  if (!birthday) {
    return ''
  }

  const age = differenceInYears(new Date(), new Date(birthday))
  let suffix: string

  let suffixes = []
  suffixes = ['л.', 'г.', 'г.']

  if (withFullSuffix) {
    suffixes = ['лет', 'год', 'года']
  }
  if (age % 100 >= 11 && age % 100 <= 14) {
    suffix = suffixes[0]
  }
  else {
    switch (age % 10) {
      case 1:
        suffix = suffixes[1]
        break
      case 2:
      case 3:
      case 4:
        suffix = suffixes[2]
        break
      default:
        suffix = suffixes[0]
        break
    }
  }
  return `${age} ${suffix}`
}

export function formatDate(dateString?: string): string {
  if (!dateString) {
    return '–'
  }

  try {
    return format(new Date(dateString), DATE_FNS_PATTERN_DATE)
  }
  catch {
    return '–'
  }
}

export function formatRelativeTime(dateString?: string): string {
  if (!dateString) {
    return ''
  }

  try {
    return formatDistanceToNow(new Date(dateString), {
      addSuffix: true,
      locale: ru,
    })
  }
  catch {
    return ''
  }
}

export function formatDateToISO(date?: Date): string | undefined {
  if (!date) {
    return undefined
  }

  try {
    return formatISO(date)
  }
  catch {
    return undefined
  }
}

export function formatTime(time: number): string {
  if (!time || !Number.isFinite(time)) {
    return '0:00'
  }

  const minutes = Math.floor(time / 60)
  const seconds = Math.floor(time % 60)
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}
